import { initializeApp } from 'firebase/app'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'

const firebaseConfig = {
    apiKey: 'AIzaSyDsYrBS4X0C36ThgIfyj-AOcG7pq_oSk7s',
    authDomain: 'tipi-ink.firebaseapp.com',
    projectId: 'tipi-ink',
    storageBucket: 'tipi-ink.appspot.com',
    messagingSenderId: '634165171036',
    appId: '1:634165171036:web:981e4bbbd6e5d568f3e799',
    measurementId: 'G-0LEK4G5JZ4',
}

const app = initializeApp(firebaseConfig)
const functions = getFunctions(app, 'europe-southwest1')

const isLocalHost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.168.'))

if (isLocalHost) {
    connectFunctionsEmulator(functions, 'localhost', 5008)
}

export { app, functions, isLocalHost }
